import { Injectable } from '@angular/core';
import { BaseService, IKeyValuePair } from './base.service';
import { Observable, Subject } from 'rxjs';
import { Reservation } from '../../models/reservation';
import { TokenService } from '../token.service';
import { AuthorizationService } from '../authorization.service';
import { MessageService } from '../message.service';
import { CacheService } from '../cache.service';
import { HttpClient } from '@angular/common/http';
import { OAuthToken } from '../../models/oauth-token.model';
import { Occupancy } from '../../models/occupancy';
import { DateHelper } from '../../utils/date-helper';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root'
})
export class ReservationService extends BaseService<Reservation> {

  protected endpointUri = 'Reservations';

  constructor(
    http: HttpClient,
    authorization: AuthorizationService,
    messages: MessageService,
    cache: CacheService,
    private storage: StorageService,
    private tokenService: TokenService
  ) {
    super(http, authorization, messages, cache);
  }

  getAll(): Observable<Reservation[]> {
    throw new Error('Method not implemented.');
  }

  get(id: string): Observable<any> {
    return this.getRequest(id);
  }

  getMyCurrent(): Observable<any> {
    return this.getAllRequest(null, [
      { key: nameof<Reservation>('PersonId'), value: String(this.storage.getPersonId()) },
      { key: nameof<Occupancy>('DateTimeFrom'), value: String(DateHelper.getUnixTime(new Date())) }
    ]);
  }

  /**
   * Create new Reservation
   *
   * @param {Reservation} entity
   * @returns {Observable<any>}
   * @memberof ReservationService
   */
  add(entity: Reservation, headers: IKeyValuePair<string, string>[]): Observable<any> {
    return this.addRequest(null, entity, headers);
  }

  /**
   * Change reservation
   *
   * @param {Reservation} entity
   * @returns {Observable<any>}
   * @memberof ReservationService
   */
  update(entity: Reservation): Observable<any> {
    return this.updateRequest(String(entity.ReservationId), null, entity, []);
  }

  delete(id: string): Observable<{}> {
    return this.deleteRequest(id);
  }

  /**
   * Load reservation template containing information from sdk etc.
   *
   * @param {string} idRessource
   * @returns {Observable<Reservation>}
   * @memberof ReservationService
   */
  getTemplate(idRessource: string): Observable<Reservation> {
    return this.getRequest(idRessource, this.endpointUri + '/templates');
  }

  getIcsLink(idReservation: number): Observable<string> {
    const obs = new Subject<string>();
    // load file token
    this.tokenService.getFileToken()
      .subscribe(
        (token: OAuthToken) => {
          const link = this.apiBaseUrl + '/' + this.endpointUri + '/' + String(idReservation) + '/calendar.ics?token=' + token.access_token;
          // push link
          obs.next(link);
        },
        (err: any) => { obs.error(err); },
        () => { obs.complete(); }
      );

    return obs;
  }

}
